export default "__VITE_ASSET__b0eb57bd__"